import { AlarmClock } from 'lucide-react';
import { cn } from '../../../lib/utils';
import { STAGE_META, STAGE_ORDER } from '../qualityConfig';

export const PIPELINE_STAGES = [
    ...STAGE_ORDER.map((id) => ({ id, ...STAGE_META[id], test: (t) => t.stage === id })),
    { id: 'due_soon', label: 'Due < 48h', icon: AlarmClock, bar: 'bg-amber-500', text: 'text-amber-600 dark:text-amber-400', test: (t) => t.due_soon },
];

export const stageTest = (id) => PIPELINE_STAGES.find((s) => s.id === id)?.test || (() => true);

export const TrackingPipeline = ({ tasks, value, onChange }) => (
    <div className="grid grid-cols-2 gap-2 sm:grid-cols-3 xl:grid-cols-6" data-testid="tracking-pipeline">
        {PIPELINE_STAGES.map((s) => {
            const count = tasks.filter(s.test).length;
            const active = value === s.id;
            const Icon = s.icon;
            return (
                <button
                    key={s.id}
                    type="button"
                    aria-pressed={active}
                    onClick={() => onChange(active ? 'all' : s.id)}
                    data-testid={`filter-stage-${s.id.replace(/_/g, '-')}`}
                    className={cn(
                        'rounded-xl border bg-card p-3 text-left transition-[border-color,box-shadow,transform] duration-200 hover:-translate-y-0.5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-violet-500',
                        active ? 'border-violet-500 ring-2 ring-violet-500/30' : 'hover:border-foreground/20'
                    )}
                >
                    <div className="flex items-center justify-between gap-2">
                        <span className="truncate font-mono text-[10px] uppercase tracking-[0.16em] text-muted-foreground">{s.label}</span>
                        <Icon className={`h-4 w-4 shrink-0 ${s.text}`} />
                    </div>
                    <p className="mt-1.5 font-heading text-2xl font-bold tabular-nums" data-testid={`stage-count-${s.id.replace(/_/g, '-')}`}>{count}</p>
                    <div className="mt-2 h-1 overflow-hidden rounded-full bg-muted">
                        <div className={`h-full rounded-full ${s.bar} transition-[width] duration-500`} style={{ width: `${tasks.length ? (count / tasks.length) * 100 : 0}%` }} />
                    </div>
                </button>
            );
        })}
    </div>
);
